import type { AlpineComponent } from 'alpinejs';

type Entry = {
	id: number;
	src: string;
};

export const productImages: AlpineComponent = {
	value: {} as Record<number, Entry>,

	push(entry: Entry) {
		this.value[entry.id] = entry;
	}
};
